let metaTimerId = null;

let timeToEnd = null;

const startTimer = function(sec, secondsElement, buttonRepeat, roundOff = false) {
    if (sec) {
        secondsElement.classList.remove('hidden');
        buttonRepeat.classList.add('hidden');
        timeToEnd = sec;
        secondsElement.querySelector('.js-timer-time-seconds').textContent = roundOff
            ? Math.floor(timeToEnd / 60) +
              ':' +
              Math.floor(timeToEnd % 60)
                  .toString()
                  .padStart(2, '0')
            : timeToEnd;
        metaTimerId = setInterval(function() {
            timeToEnd = --sec;
            secondsElement.querySelector('.js-timer-time-seconds').textContent = roundOff
                ? Math.floor(timeToEnd / 60) +
                  ':' +
                  Math.floor(timeToEnd % 60)
                      .toString()
                      .padStart(2, '0')
                : timeToEnd;
            buttonRepeat.classList.add('hidden');
            if (sec === 0) {
                stopTimer();
                secondsElement.classList.add('hidden');
                buttonRepeat.classList.remove('hidden');
            }
        }, 1000);
    }
};

const stopTimer = function() {
    clearInterval(metaTimerId);
};

export default startTimer;
